module.exports = __webpack_public_path__ + "media/images/lb/982-2047aa0806239a44d50ac5a8005dbeec.svg";